<template>
    <span class="h2 mt-8">
        Event documents
    </span>

    <div class="grid gap-2">

        <a :href="document.file" target="_blank" :title="'Download ' + document.name" v-for="document in documents">

            <div
                class="grid gap-2 md:gap-x-4 md:grid-cols-[auto_1fr] items-center text-primary-dark px-4 py-2 bg-light lg:grid-cols-1 xl:grid-cols-[auto_1fr]">

                <span class="inline-block w-[40px]">
                    <InlineSvg src="icons/icon-download.svg" />
                </span>

                <span>
                    {{ document.name }}
                </span>

            </div>

        </a>

    </div>
</template>

<script>
import InlineSvg from "@app/components/InlineSvg.vue";

export default {
    components: {
        InlineSvg,
    },

    props: {
        documents: {
            type: Array,
            required: true,
        },
    },

    data() {
        return {
            isLoading: false,
        };
    },
}
</script>